import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import styled from "styled-components";
import tw from "twin.macro";

import { MdAddCircle } from "react-icons/md";

const StyledButton = styled(Button)`
  && {
    ${tw`bg-white p-3 hover:bg-gray-100`}
  }
`;

const DashboardHeader = () => {
  const history = useHistory();
  const handleAddMembership = () => {
    history.push("/add-membership");
  };

  const handleUpdateMembership = () => history.push("/update-membership");
  const handleAddOrganisation = () => history.push("/add-organisation");

  return (
    <div className="py-8 px-16">
      <div className="lg:flex items-center justify-between">
        <div className="text-3xl font-rubik font-bold leading-10">
          <h3>Dashboard</h3>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
